import { GET_PROCESSES, ADD_PROCESSES, UPDATE_PROCESS_STEPS, UPDATE_PROCESS_STEP_COMPLETED, DELETE_PROCESSES } from 'redux/actionTypes';

function findProcessIndex(state, processId) {
    return state.findIndex(process => process.id === processId);
};

export default function processes(state = [], action) {
    switch(action.type) {
        case GET_PROCESSES:
            return [
                ...state,
                ...action.payload
            ];
        case ADD_PROCESSES:
            return [
                ...action.payload,
                ...state
            ];
        case UPDATE_PROCESS_STEPS:
            const stepIndex = findProcessIndex(state, action.payload.id);
            return [
                ...state.slice(0, stepIndex),
                {
                    ...state[stepIndex],
                    steps: action.payload.steps
                },
                ...state.slice(stepIndex + 1)
            ];
        case UPDATE_PROCESS_STEP_COMPLETED:
            const compProcessIndex = findProcessIndex(state, action.payload.salesOrderProductId);
            const compStepIndex = state[compProcessIndex].steps.findIndex(
                step => step.id === action.payload.id
            );
            return [
                ...state.slice(0, compProcessIndex),
                {
                    ...state[compProcessIndex],
                    steps: [
                        ...state[compProcessIndex].steps.slice(0, compStepIndex),
                        {
                            ...state[compProcessIndex].steps[compStepIndex],
                            completed: action.payload.completed
                        },
                        ...state[compProcessIndex].steps.slice(compStepIndex + 1)
                    ]
                },
                ...state.slice(compProcessIndex + 1)
            ];
        case DELETE_PROCESSES:
            const updatedProcesses = state.filter(process => process.salesOrderId !== action.payload.id);
            return [
                ...updatedProcesses
            ];
        default:
            return state;
    }
};